// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(120deg, #a5d6a7, #004d40, #f0f8e7);
  background-size: 300% 300%;
  animation: gradient-bg 8s ease infinite;
}

@keyframes gradient-bg {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Signup Form */
.signup-form {
  background: #a5d6a7;
  backdrop-filter: blur(8px);
  padding: 30px;
  border-radius: 15px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: fadeIn 1s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.signup-form h1 {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.error-message {
  font-size: 14px;
  color: red;
  text-align: center;
}

.success-message {
  font-size: 14px;
  color: green;
  text-align: center;
}

.input-field {
  width: 100%;
  padding: 10px 14px;
  border: none;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.6);
  transition: border 0.3s, background 0.3s;
  box-sizing: border-box;
}

.input-field:focus {
  outline: none;
  border: 2px solid #4a90e2;
  background: rgba(255, 255, 255, 0.85);
}

select.input-field {
  appearance: none;
  cursor: pointer;
}

.submit-buttonk {
  width: 100%;
  padding: 12px 0;
  background-color: #004d40;
  color: white;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.submit-buttonk:hover {
  background-color: #357ab8;
}

.submit-buttonk:active {
  transform: scale(0.98);
}

@media (max-width: 768px) {
  .signup-wrapper {
    padding: 16px;
    height: auto;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .signup-form {
    max-width: 100%;
    width: 100%;
    padding: 24px;
    border-radius: 12px;
    gap: 16px;
  }

  .signup-form h1 {
    font-size: 22px;
  }

  .input-field {
    width: 100%;
    font-size: 16px;
    box-sizing: border-box;
  }
}

@media (max-width: 480px) {
  .signup-wrapper {
    padding: 12px;
  }

  .signup-form {
    padding: 20px;
    border-radius: 10px;
    gap: 14px;
  }

  .signup-form h1 {
    font-size: 20px;
  }
}

.login-redirect {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin-top: -10px;
}

.login-redirect span {
  color: #004D40;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.login-redirect span:hover {
  color: #357ab8;
}`, "",{"version":3,"sources":["webpack://./src/styles/Signup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8DAA8D;EAC9D,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".signup-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(120deg, #a5d6a7, #004d40, #f0f8e7);\n  background-size: 300% 300%;\n  animation: gradient-bg 8s ease infinite;\n}\n\n@keyframes gradient-bg {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n/* Signup Form */\n.signup-form {\n  background: #a5d6a7;\n  backdrop-filter: blur(8px);\n  padding: 30px;\n  border-radius: 15px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: fadeIn 1s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.signup-form h1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.error-message {\n  font-size: 14px;\n  color: red;\n  text-align: center;\n}\n\n.success-message {\n  font-size: 14px;\n  color: green;\n  text-align: center;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  border-radius: 6px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  background: rgba(255, 255, 255, 0.6);\n  transition: border 0.3s, background 0.3s;\n  box-sizing: border-box;\n}\n\n.input-field:focus {\n  outline: none;\n  border: 2px solid #4a90e2;\n  background: rgba(255, 255, 255, 0.85);\n}\n\nselect.input-field {\n  appearance: none;\n  cursor: pointer;\n}\n\n.submit-buttonk {\n  width: 100%;\n  padding: 12px 0;\n  background-color: #004d40;\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.submit-buttonk:hover {\n  background-color: #357ab8;\n}\n\n.submit-buttonk:active {\n  transform: scale(0.98);\n}\n\n@media (max-width: 768px) {\n  .signup-wrapper {\n    padding: 16px;\n    height: auto;\n    min-height: 100vh;\n    box-sizing: border-box;\n  }\n\n  .signup-form {\n    max-width: 100%;\n    width: 100%;\n    padding: 24px;\n    border-radius: 12px;\n    gap: 16px;\n  }\n\n  .signup-form h1 {\n    font-size: 22px;\n  }\n\n  .input-field {\n    width: 100%;\n    font-size: 16px;\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 480px) {\n  .signup-wrapper {\n    padding: 12px;\n  }\n\n  .signup-form {\n    padding: 20px;\n    border-radius: 10px;\n    gap: 14px;\n  }\n\n  .signup-form h1 {\n    font-size: 20px;\n  }\n}\n\n.login-redirect {\n  text-align: center;\n  font-size: 14px;\n  color: #333;\n  margin-top: -10px;\n}\n\n.login-redirect span {\n  color: #004D40;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.login-redirect span:hover {\n  color: #357ab8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
